import { DashboardItemsActionType, DashboardItems } from "./types";
import { createReducer } from 'typesafe-actions';
import { DashboardItemActionType } from './actions';
import { RelevantWebsitePreference,
         RelevantWebsiteWithPreference
} from "../../api/user";

const reducer = createReducer<DashboardItems, DashboardItemActionType>({
        applications_loaded: {loaded: false, hasError: false},
        relevant_websites_loaded: {loaded: false, hasError: false}
    }, {
    [DashboardItemsActionType.SET_USED_APPLICATIONS]: (state: DashboardItems, action) => {
        return { ...state, used_applications: [...action.payload] }
    },
    [DashboardItemsActionType.SET_RECOMMENDED_APPLICATIONS]: (state: DashboardItems, action: any) => {
        return { ...state, recommended_applications: [...action.payload] }
    },
    [DashboardItemsActionType.SET_AUTHORIZED_APPLICATIONS]: (state: DashboardItems, action: any) => {
        return { ...state, authorized_applications: [...action.payload] }
    },
    [DashboardItemsActionType.SET_RELEVANT_WEBSITES]: (state: DashboardItems, action: any) => {
        return { ...state, relevant_websites: [...action.payload] }
    },
    [DashboardItemsActionType.SET_RELEVANT_WEBSITES_PREFERENCES]: (state: DashboardItems, action) => {

        const relevantWebsitesWithPreferences = (state.relevant_websites || []).map((relevantWebsite: RelevantWebsiteWithPreference) => {
            const preference = action.payload.filter((pref: RelevantWebsitePreference) => pref.id === relevantWebsite.id)

            if (preference.length === 0) {
                delete relevantWebsite.hidden;
                delete relevantWebsite.display_order;

                return {...relevantWebsite}
            }

            return {...relevantWebsite, ...preference[0]};
        }).sort((a, b) => (a.display_order || 0) - (b.display_order || 0))

        return { ...state, relevant_websites: relevantWebsitesWithPreferences, relevant_websites_preferences: action.payload }
    },
    [DashboardItemsActionType.SET_LOADED_FALSE]: (state: DashboardItems) => {
        return { ...state, applications_loaded: {loaded: false, hasError: false}, relevant_websites_loaded: {loaded: false, hasError: false}}
    },
    [DashboardItemsActionType.SET_APPLICATIONS_LOADED]: (state: DashboardItems, action) => {
        return { ...state, applications_loaded: action.payload }
    },
    [DashboardItemsActionType.SET_RELEVANT_WEBSITES_LOADED]: (state: DashboardItems, action) => {
        return { ...state, relevant_websites_loaded: action.payload }
    }
});

export { reducer as dashboardItemsReducer };
